/*
 * filename: routers.js
 * mainly responsivle for all routes component
 * change and sidebar routlist menu item
 * */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import Drawer from 'material-ui/Drawer'
import classNames from 'classnames'
import RoutesList from './routesList.js'
// import RoutesListClient from './routesListClient.js'
// import RoutesListManagement from './routesListManagement.js'
import RoutesListSupervisor from './routesListSupervisor.js'
import { Scrollbars } from 'react-custom-scrollbars'
import * as Constants from '../utils/constants'


class SidebarMenuRouters extends Component {
  constructor (props) {
    super(props)
    this.state = {menuOpen: false, vp: this.props.place, profileHome: this.props.profileHome}
    this.menuCollapseWithResize = this.menuCollapseWithResize.bind(this)
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  // menu collapse when on mobile function
  menuCollapseWithResize () {
    if (window.innerWidth < 991) {
      this.setState({menuOpen: false})
    }
    if (window.innerWidth > 991) {
      this.setState({menuOpen: true})
    }
  }

  // Sidebar collapse when tablet
  componentDidMount () {
    // window.addEventListener('resize', this.menuCollapseWithResize);

    if (window.innerWidth < 991) {
      this.setState({menuOpen: false})
    }

  }

  // Sidebar collapse when tablet
  componentWillUnmount () {
    // window.removeEventListener('resize', this.menuCollapseWithResize);
  }

  // Sidebar toggle
  toggleMenu () {
    this.setState(prevState => ({
      menuOpen: !prevState.menuOpen
    }))
  }

  callback = (dataFromChild) => {
    this.props.callback(dataFromChild);
    this.setState({vp: dataFromChild})
  };

  render () {

    var userData = JSON.parse(localStorage.getItem('userData'))

    const headerStyle = {
      background: '#000',
      cursor: 'pointer'
    }

    const containerStyle = {
      background: this.props.colorSidebar.color
    }

    // Sidebar class based on bg color
    const sidebarClass = classNames({
      'menu-drawer': true,
      'has-bg': true,
    })

    // header left part with logo and toggle button
    const HeaderLogoWithMenu = () => (
      <div className="an-header" style={headerStyle} onClick={this.toggleMenu}>
        <div className="header-left align-middle">
          <h1 className="brand user-name-header"><i className="material-icons" style={{
            color: '#FFF',
            verticalAlign: 'bottom'
          }}>format_indent_decrease</i> {this.props.place}</h1>
        </div>
      </div>
    )

    let route = null
    switch (userData.rol) {
      case Constants.ROL.CLIENT.url:
        route = <RoutesListSupervisor profile={this.props.profile} bu={userData.businessUnit} callback={this.callback}/>;
        break
      case Constants.ROL.MANAGEMENT.url:
        route = <RoutesListSupervisor profile={this.props.profile} bu={userData.businessUnit} callback={this.callback}/>;
        break
      case Constants.ROL.SUPERVISOR.url:
        route = <RoutesListSupervisor profile={this.props.profile} bu={userData.businessUnit} callback={this.callback}/>;
        break
      default:
        route = <RoutesList profile={this.props.profile} callback={this.callback} profileHome={this.state.profileHome}/>;
        break
    }

    return (
      <div>
        <div className="readmin-sidebar">
          <HeaderLogoWithMenu/>
          <Drawer open={this.state.menuOpen}
                  className={sidebarClass}
                  containerClassName="sidebar-initial-color"
                  containerStyle={containerStyle}
          >
            <Scrollbars>
              {route}
            </Scrollbars>
          </Drawer>
        </div>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    colorHeader: state.headerActiveStyle,
    colorSidebar: state.sidebarActiveStyle
  }
}

export default connect(mapStateToProps)(SidebarMenuRouters)



// WEBPACK FOOTER //
// ./src/routers/routers.js